import { AutocompleteInput, DeleteButton, SaveButton } from "@/components/admin";
import { Card } from "@/components/ui/card";
import { Landmark } from "lucide-react";
import { Edit, ReferenceInput, SimpleForm, TextInput } from "../common";

const DepartmentEditToolbar = () => (
  <div className="form-toolbar-premium">
    <DeleteButton className="btn-delete-action" />
    <SaveButton className="btn-green-action" label="Update Department" />
  </div>
);

export const DepartmentEdit = () => (
  <Edit title="Edit Department" actions={false}>
    <Card className="form-container">
      <div className="form-header-premium">
        <Landmark className="w-6 h-6 text-emerald-600" />
        <h2 className="text-2xl font-bold text-slate-900">Edit Department Details</h2>
      </div>
      <SimpleForm toolbar={<DepartmentEditToolbar />}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <TextInput source="name" label="Department Name" />
          <TextInput source="code" label="Department Code" />
          <ReferenceInput source="head_employee_id" reference="employees">
            <AutocompleteInput label="Department Head" optionText="name" />
          </ReferenceInput>
        </div>
      </SimpleForm>
    </Card>
  </Edit>
);

